import Field from '../Field'
import cloneDeep from 'lodash/cloneDeep'

export default class extends Field {
  static name = 'object'

  constructor (initial) {
    super(typeof initial === 'undefined' ? {} : initial)
  }

  /** @inheritdoc */
  reset () {
    this._current = cloneDeep(this._default)
  }
}
